<template>
    <button
        type="button"
        class="result"
        :aria-label="item.companyName"
        :class="{ 'result--selected': isSelected }"
        @click="handleClick"
    >
        <img
            v-if="item.country"
            :src="item.country.flagUrl"
            :alt="item.country.name"
            v-tippy="item.country.name"
            class="result__flag"
        />
        <span v-text="item.companyName" :title="item.companyName" class="result__name" />
        <span v-if="item.sectors.length" class="result__sector">
            <span class="sector" :title="item.sectors[0].name" v-text="item.sectors[0].name"/>
        </span>
        <span v-if="item.shortType" class="result__type">
            <span class="sector" :title="item.shortType" v-text="item.shortType"/>
        </span>
    </button>
</template>
<script>
export default {
    name: 'SearchModalResult',
    props: {
        item: {
            type: Object,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        handleClick: function(){
            this.$emit('on-selected', this.item);
        }
    }
}
</script>
<style lang="scss" scoped>
    .result {
        appearance: none;
        -wekit-appearance: none;
        display: flex;
        align-items: center;
        width: 100%;
        background-color: white;
        border-radius: .4rem;
        padding: 1rem;
        border: .1rem solid transparent;
        column-gap: 1.5rem;
        font-family: "Axiforma", sans-serif;
        cursor: pointer;

        .result__flag {
            flex: 0 0 2.4rem;
            width: 2.4rem;
        }

        .result__name {
            flex: 1 0 auto;
            text-align: left;
            font-weight: 500;
            font-size: 1.4rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            position: relative;
            top: .2rem;
        }

        .result__sector {
            flex: 0 0 12rem;
            display: flex;
            justify-content: flex-start;
        }

        .result__type {
            flex: 0 0 10rem;
            display: flex;
            justify-content: flex-start;
        }

        .result__sector,
        .result__type {
            .sector {
                max-width: 12rem;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                margin: 0;
            }
        }

        &.result--selected {
            background-color: rgba(190, 33, 67, 0.08);
            border: 1px solid #CFCFCF;
        }
    }
</style>
